import React, { useEffect, useState } from 'react';
import useTranslation from '../../hooks/useTranslation';
import InAppRankSystemUpdate from '../../containers/AppManagement/FixAppData/InAppRankSystem/InAppRankSystemUpdate';

const BOTableInAppRankSystem = ({
  schema,
  rows,
  loading,
  className,
  onChangeLastRank,
  onChangeTargetType,
  onChangeWithoutTarget,
  onUpdate,
}) => {
  // -- component const --//
  const { t } = useTranslation();

  const [head, setHead] = useState([]);
  const [body, setBody] = useState();

  const InputStyle = {
    width: '-webkit-fill-available',
    border: 'none',
  }

  // -- useSelector & dispatch --//

  // -- state --//

  // -- func & handler --//
  const handleInputChange = (index, field, value) => {
    const updatedBody = [...body];
    updatedBody[index] = {
      ...updatedBody[index],
      [field]: value
    };
    setBody(updatedBody);

    const updatedRow = updatedBody[index];
    if (field === 'lastRank') onChangeLastRank(value, updatedRow);
    if (field === 'targetType') onChangeTargetType(value, updatedRow);
    if (field === 'withoutTarget') onChangeWithoutTarget(value, updatedRow);
  };

  const layoutBody = () => {
    if (loading) {
      return (
        <tr>
          <td colSpan={head?.length} style={{ textAlign: 'center', backgroundColor: '#FAFBFC' }}>
            {t('table.loading')}
          </td>
        </tr>
      );
    }

    if (body?.length > 0) {
      return body?.map((row, rowIndex) => (
        <tr key={row?.key}>
          <td>{row?.rankType}</td>
          <td>
            <input
              type="number"
              value={row?.lastRank}
              onChange={(event) => handleInputChange(rowIndex, 'lastRank', Number(event.target.value))}
              style={InputStyle}
            />
          </td>
          <td>
            <input
              type="number"
              value={row?.targetType}
              onChange={(event) => handleInputChange(rowIndex, 'targetType', Number(event.target.value))}
              style={InputStyle}
            />
          </td>
          <td>
            <input
              type="text"
              value={row?.withoutTarget}
              onChange={(event) => handleInputChange(rowIndex, 'withoutTarget', event.target.value)}
              style={InputStyle}
            />
          </td>
          <td>
            <InAppRankSystemUpdate onClick={() => onUpdate(row)} />
          </td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan={head?.length} style={{ textAlign: 'center', backgroundColor: '#FAFBFC' }}>
          {t('table.log.empty')}
        </td>
      </tr>
    );
  };

  // -- react hooks --//
  useEffect(() => {
    setHead(schema?.head || []);
  }, [schema]);

  useEffect(() => {
    if (rows && schema) {
      setBody(schema?.body(rows));
    }
  }, [schema, rows]);

  // -- render --//
  return (
    <table className={className}>
      <thead>
      <tr>
        {head?.map((i, index) => (
          // 크기 조절
          <th
            key={index}
            style={i !== '제외할 대상' ? { width: 85, maxWidth: 100 } : {}}
          >
            {i}
          </th>
        ))}
      </tr>
      </thead>
      <tbody>{layoutBody()}</tbody>
    </table>
  );
};

export default BOTableInAppRankSystem;
